<template>
  <!-- Si usas Nyx/otro componente -->
  <OEENYX2 ref="OEENYX2" v-if="formulaNyx && permisoVista('dashboard','r')" />

  <!-- Root del OEE: NO 100vh, sino 100% del tab -->
  <div
    v-else-if="permisoVista('dashboard','r')"
    ref="fsRoot"
    class="oee-surface px-6"
  >
    <v-snackbar v-model="error" top color="error">
      <ul class="ma-0">
        <li v-for="(e, i) in errores" :key="i">{{ e }}</li>
      </ul>
      <v-btn text @click="error = false">Cerrar</v-btn>
    </v-snackbar>

    <!-- Header fijo -->
    <div ref="fsHeader" class="oee-header text-center">
      <div class="text-h6 font-weight-bold">OEE del Área: {{ areaConsultadaNombre }}</div>
      <div class="text-subtitle-1 font-weight-bold">Rango Consultado: {{ rangoFechasLabel }}</div>
    </div>

    <!-- Body flexible (sin scroll) -->
    <div v-if="viewData && !cargando" class="oee-body">
      <!-- Fila 1: Tarjetas informativas -->
      <v-row ref="metricsRow" dense class="metrics-row ma-0 pa-1">
        <v-col cols="3" class="d-flex pa-1">
          <v-card class="flex-grow-1 d-flex metric-card" color="#2a6099" dark>
            <v-card-text class="text-center align-self-center py-1 px-2">
              <div class="subtitle-1 font-weight-bold">Disponibilidad</div>
              <ICountUp
                :delay="500"
                :endVal="datosAgrupados.disponibilidadPromedio"
                class="subtitle-1 font-weight-medium"
                :options="{ decimalPlaces: 2, decimal: '.', suffix: '%' }"
              />
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="3" class="d-flex pa-1">
          <v-card class="flex-grow-1 d-flex metric-card" color="#2a6099" dark>
            <v-card-text class="text-center align-self-center py-1 px-2">
              <div class="subtitle-1 font-weight-bold">Rendimiento</div>
              <ICountUp
                :delay="500"
                :endVal="datosAgrupados.rendimientoPromedio"
                class="subtitle-1 font-weight-medium"
                :options="{ decimalPlaces: 2, decimal: '.', suffix: '%' }"
              />
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="3" class="d-flex pa-1">
          <v-card class="flex-grow-1 d-flex metric-card" color="#2a6099" dark>
            <v-card-text class="text-center align-self-center py-1 px-2">
              <div class="subtitle-1 font-weight-bold">Calidad</div>
              <ICountUp
                :delay="500"
                :endVal="datosAgrupados.calidadPromedio"
                class="subtitle-1 font-weight-medium"
                :options="{ decimalPlaces: 2, decimal: '.', suffix: '%' }"
              />
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="3" class="d-flex pa-1">
          <v-card class="flex-grow-1 d-flex metric-card" color="#2a6099" dark>
            <v-card-text class="text-center align-self-center py-1 px-2">
              <div class="subtitle-1 font-weight-bold">OEE</div>
              <ICountUp
                :delay="500"
                :endVal="datosAgrupados.oeePromedio"
                class="subtitle-1 font-weight-medium"
                :options="{ decimalPlaces: 2, decimal: '.', suffix: '%' }"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Fila 2: Gráficas 2x2 -->
      <v-row dense class="charts-row ma-0 pa-1">
        <v-col cols="6" class="d-flex pa-1">
          <v-card class="flex-grow-1 chart-card">
            <v-card-title class="text-subtitle-2 py-1">Disponibilidad</v-card-title>
            <v-card-text class="chart-body py-0">
              <apexchart :height="chartH" :options="serie1" :series="chartOptions1" />
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6" class="d-flex pa-1">
          <v-card class="flex-grow-1 chart-card">
            <v-card-title class="text-subtitle-2 py-1">Rendimiento</v-card-title>
            <v-card-text class="chart-body py-0">
              <apexchart :height="chartH" :options="serie2" :series="chartOptions2" />
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6" class="d-flex pa-1">
          <v-card class="flex-grow-1 chart-card">
            <v-card-title class="text-subtitle-2 py-1">Calidad</v-card-title>
            <v-card-text class="chart-body py-0">
              <apexchart :height="chartH" :options="serie3" :series="chartOptions3" />
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6" class="d-flex pa-1">
          <v-card class="flex-grow-1 chart-card">
            <v-card-title class="text-subtitle-2 py-1">OEE</v-card-title>
            <v-card-text class="chart-body py-0">
              <apexchart :height="chartH" :options="serie4" :series="chartOptions4" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- Cargando -->
    <div v-else-if="cargandoData || cargando" class="oee-loading text-center">
      <h4 class="mb-2">Cargando</h4>
      <v-progress-circular :size="75" color="green" indeterminate />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from "axios";
import ICountUp from "vue-countup-v2";
import moment from "moment";
import DownloadBtn from '../../../DownloadBtn.vue';
import OEENYX2 from '../../Dashboards/OEENYX2.vue';
import WeekMultiPicker from '../../../WeekMultiPicker.vue';
import WeekPickerCalendar from '../../../WeekPickerCalendar.vue';
import ApexCharts from 'apexcharts';

export default {
  components: {
    OEENYX2,
    ICountUp,
    DownloadBtn,
    WeekMultiPicker,
    WeekPickerCalendar
  },
  props: {
    rangoInicial: {
      type: String,
      default: "semanaPasadaLaboral",
    },
  },
  computed: {
    ...mapState({
      nombreEmpresa: 'nombreEmpresa',
      oeeRendimientoLabel: 'oeeRendimientoLabel',
      nuevoReporteOee: 'nuevoReporteOee',
      formulaNyx: 'formulaNyx',
    }),
    areaConsultadaNombre() {
      const a = (this.areas || []).find(x => Number(x.idArea) === Number(this.filtros.idsAreas[0]));
      return a?.nombre || (this.filtros.idsAreas[0] ? `ID ${this.filtros.idsAreas[0]}` : "");
    },
    rangoFechasLabel() {
      const fmt = (v) => {
        if (!v) return null;
        const m = moment(String(v).trim(), ["YYYY-MM-DD", "YYYY-MM-DD HH:mm:ss", moment.ISO_8601], true);
        return m.isValid() ? m.format("DD/MM/YYYY") : null;
      };

      const d = fmt(this.filtros.desde);
      const h = fmt(this.filtros.hasta);

      if (!d || !h) return "—";
      return `${d} al ${h}`;
    },
    url() {
      // Solo usar endpoint estándar para caso no-NYX
      var endpoint = 'OEERangoTurnos';
      var url = `/OEEV2/${endpoint}?`;
      
      url += `Desde=${this.filtros.desde}&Hasta=${this.filtros.hasta}`;
      
      if (this.filtros.idsTurnos != null)
        url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos, "IdsTurnos", false);
      
      url += this.$utils.arrays.urlQuery(this.filtros.idsAreas, "IdsAreas", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsOTS, "IdsOTS", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsArticulos, "IdsArticulos", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsMaquinaInstancias, "IdsMaquinasInstancias", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsPersonas, "IdsPersonas", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsClientes, "IdsClientes", false);
      
      return url;
    }
  },
  data() {
    return {
      mostrarAviso: true,
      tipoAgrupacion: 'semana',
      mesesDisponibles: [
        { value: 1, text: 'Enero' },
        { value: 2, text: 'Febrero' },
        { value: 3, text: 'Marzo' },
        { value: 4, text: 'Abril' },
        { value: 5, text: 'Mayo' },
        { value: 6, text: 'Junio' },
        { value: 7, text: 'Julio' },
        { value: 8, text: 'Agosto' },
        { value: 9, text: 'Septiembre' },
        { value: 10, text: 'Octubre' },
        { value: 11, text: 'Noviembre' },
        { value: 12, text: 'Diciembre' }
      ],
      añosDisponibles: [],
      cargando: false,
      cargandoData: false,
      semanas: [],
      viewData: false,
      renderizar: false,
      expanded: [],
      error: false,
      errores: [],
      filtros: {
        desde: null,
        hasta: null,
        semanasSeleccionadas: [], // <== [{year, week, desde, hasta, etiqueta}]
        mesesSeleccionados: [],
        año: new Date().getFullYear(),
        idsTurnos: [],
        idsAreas: [6], // Inicializar con primera área
        idsOTS: [],
        idsArticulos: [],
        idsMaquinaInstancias: [],
        idsPersonas: [],
        idsClientes: []
      },
      turnos: [],
      areas: [],
      ots: [],
      articulos: [],
      maquinasIns: [],
      operadores: [],
      clientes: [],
      datos: {},
      datosAgrupados: {
        disponibilidadPromedio: 0,
        rendimientoPromedio: 0,
        calidadPromedio: 0,
        oeePromedio: 0,
        periodos: []
      },
      serie1: {},
      chartOptions1: [],
      serie2: {},
      chartOptions2: [],
      serie3: {},
      chartOptions3: [],
      serie4: {},
      chartOptions4: [],
      headersAgrupados: [
        {
          text: "Periodo",
          align: "center",
          value: "etiqueta"
        },
        {
          text: "Desde",
          align: "center",
          value: "fechaInicio"
        },
        {
          text: "Hasta",
          align: "center",
          value: "fechaFin"
        },
        {
          text: "Disponibilidad",
          align: "center",
          value: "disponibilidad"
        },
        {
          text: "Rendimiento",
          align: "center",
          value: "rendimiento"
        },
        {
          text: "Calidad",
          align: "center",
          value: "calidad"
        },
        {
          text: "OEE",
          align: "center",
          value: "oee"
        },
        { text: '', value: 'data-table-expand' }
      ],
      carrusel: {
        enabled: true,
        segundos: 20,
        timer: null,
        idx: 0,
        areasRotacion: [6, 9, 11]
      }
    };
  },
  methods: {
    onAplicar(weeks) {
      const lista = weeks || this.semanas || [];
      // 1) guarda el rango min–max
      this.setRangeFromWeeks(lista);
      // 2) guarda la selección exacta para que la función pueda filtrar
      this.filtros.semanasSeleccionadas = lista.map(w => ({
        year: w.isoYear,
        week: w.isoWeek,
        desde: w.start,       // 'YYYY-MM-DD'
        hasta: w.end,         // 'YYYY-MM-DD'
        etiqueta: `Sem. ${String(w.isoWeek).padStart(2,'0')} '${String(w.isoYear).slice(-2)}`
      }));
    },
    setRangeFromWeeks(weeks) {
      if (!weeks || !weeks.length) {
        this.filtros.desde = null;
        this.filtros.hasta = null;
        return;
      }
      const starts = weeks.map(w => w.start).sort(); // 'YYYY-MM-DD'
      const ends   = weeks.map(w => w.end).sort();
      this.filtros.desde = starts[0];
      this.filtros.hasta = ends[ends.length - 1];
    },
    nombreArticulo: (articulo) => `[${articulo.codigo}] - ${articulo.nombre}`,
    nombreMaquina: maquina => ` [${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`,
    nombrePersona: (persona) => persona.nombre + " " + persona.paterno + " " + persona.materno,
      onWeeksChanged() {
      const arr = this.filtros.semanasSeleccionadas;
      if (!arr || arr.length === 0) {
        this.filtros.desde = null;
        this.filtros.hasta = null;
        return;
      }
      const mins = arr.map(x => x.desde).sort()[0];
      const maxs = arr.map(x => x.hasta).sort().slice(-1)[0];
      this.filtros.desde = mins;
      this.filtros.hasta = maxs;
    },
    
setRangoSemanaPasadaLaboral() {
  const lunesEstaSemana = moment().startOf('isoWeek');       // lunes actual
  const lunesPasado = lunesEstaSemana.clone().subtract(1, 'week');
  const sabadoPasado = lunesPasado.clone().add(5, 'days');   // +5 => sabado

  this.filtros.desde = lunesPasado.format("YYYY-MM-DD");
  this.filtros.hasta = sabadoPasado.format("YYYY-MM-DD");
},

setRangoDiaAnterior() {
  const ayer = moment().subtract(1, "day").format("YYYY-MM-DD");
  this.filtros.desde = ayer;
  this.filtros.hasta = ayer;
},

setRangoInicial() {
  if (this.rangoInicial === "diaAnterior") {
    this.setRangoDiaAnterior();
    return;
  }

  this.setRangoSemanaPasadaLaboral();
},

startCarrusel() {
  this.stopCarrusel();
  if (!this.carrusel?.enabled) return;

  // seguridad: solo ids válidos
  const list = (this.carrusel.areasRotacion || []).filter(n => Number.isFinite(+n));
  if (!list.length) return;

  this.carrusel.timer = setInterval(() => {
    // evita encimar requests
    if (this.cargando) return;

    this.carrusel.idx = (this.carrusel.idx + 1) % list.length;
    this.filtros.idsAreas = [list[this.carrusel.idx]];

    // refresca el reporte
    this.obtenerDatos();
  }, (this.carrusel.segundos || 20) * 1000);
},

stopCarrusel() {
  if (this.carrusel?.timer) clearInterval(this.carrusel.timer);
  if (this.carrusel) this.carrusel.timer = null;
},


soloDomingos(fecha) {
  return moment(fecha).isoWeekday() === 7;
},

validarFechaDesde(fecha) {
  if (!fecha) return;

  const diaSemana = moment(fecha).isoWeekday();
  if (diaSemana !== 1) {
    const lunes = moment(fecha).startOf('isoWeek').format('YYYY-MM-DD');
    this.filtros.desde = lunes;
  } else {
    this.filtros.desde = moment(fecha).format('YYYY-MM-DD');
  }

  // Llenar automáticamente el domingo de esa semana
  this.filtros.hasta = moment(this.filtros.desde).endOf('isoWeek').format('YYYY-MM-DD');
},

validarFechaHasta(fecha) {
  if (!fecha) return;

  const diaSemana = moment(fecha).isoWeekday();
  if (diaSemana !== 7) {
    const domingo = moment(fecha).endOf('isoWeek').format('YYYY-MM-DD');
    this.filtros.hasta = domingo;
  } else {
    this.filtros.hasta = moment(fecha).format('YYYY-MM-DD');
  }
},


    
    obtenerRangoFechasMeses() {
      if (this.filtros.mesesSeleccionados.length === 0) {
        return { desde: null, hasta: null };
      }
      
      const mesesOrdenados = [...this.filtros.mesesSeleccionados].sort((a, b) => a - b);
      const primerMes = mesesOrdenados[0];
      const ultimoMes = mesesOrdenados[mesesOrdenados.length - 1];
      
      const desde = moment(`${this.filtros.año}-${primerMes}-01`).format('YYYY-MM-DD');
      const hasta = moment(`${this.filtros.año}-${ultimoMes}-01`).endOf('month').format('YYYY-MM-DD');
      
      return { desde, hasta };
    },

    esRangoDeUnDia() {
      return this.filtros.desde && this.filtros.hasta &&
        moment(this.filtros.desde).isSame(moment(this.filtros.hasta), 'day');
    },

    agruparDatosPorDias(datos) {
      if (!datos || !datos.resumenDias || datos.resumenDias.length === 0) return [];

      const dias = {};

      datos.resumenDias.forEach(dia => {
        const fechaDia = moment(dia.fecha);
        const etiqueta = fechaDia.format('DD/MM/YYYY');

        if (!dias[etiqueta]) {
          dias[etiqueta] = {
            id: Number(fechaDia.format('YYYYMMDD')),
            etiqueta,
            fechaInicio: fechaDia.format('YYYY-MM-DD'),
            fechaFin: fechaDia.format('YYYY-MM-DD'),
            dias: [],
            disponibilidad: 0, rendimiento: 0, calidad: 0, oee: 0,
            totalPiezas: 0, piezasTeoricas: 0, piezasOk: 0, piezasNoOk: 0,
            tiempoActivo: 0, tiempoParos: 0, tiempoParoNoPlan: 0, tiempoBruto: 0, scrap: 0
          };
        }

        dias[etiqueta].dias.push(dia);
      });

      Object.values(dias).forEach(periodo => {
        if (!periodo.dias.length) return;
        periodo.totalPiezas = periodo.dias.reduce((s,d)=>s+d.totalPiezas,0);
        periodo.piezasTeoricas = periodo.dias.reduce((s,d)=>s+d.piezasTeoricas,0);
        periodo.piezasOk = periodo.dias.reduce((s,d)=>s+d.piezasOk,0);
        periodo.piezasNoOk = periodo.dias.reduce((s,d)=>s+d.piezasNoOk,0);
        const tBruto = periodo.dias.reduce((s,d)=>s+(d.tiempoBruto*3600),0);
        const tNeto = periodo.dias.reduce((s,d)=>s+(d.tiempoNeto*3600),0);
        const tParos = periodo.dias.reduce((s,d)=>s+(d.tiempoParos*3600),0);
        const tNoPlan = periodo.dias.reduce((s,d)=>s+(d.tiempoParoNoPlan*3600),0);
        periodo.tiempoBruto = tBruto; periodo.tiempoActivo = tNeto; periodo.tiempoParos = tParos; periodo.tiempoParoNoPlan = tNoPlan;
        periodo.disponibilidad = tBruto>0 ? ((tBruto - tNoPlan)/tBruto)*100 : 0;
        periodo.rendimiento = periodo.piezasTeoricas>0 ? (periodo.totalPiezas/periodo.piezasTeoricas)*100 : 0;
        periodo.calidad = periodo.totalPiezas>0 ? (periodo.piezasOk/periodo.totalPiezas)*100 : 0;
        periodo.oee = (periodo.disponibilidad*periodo.rendimiento*periodo.calidad)/10000;
        periodo.scrap = periodo.totalPiezas>0 ? (periodo.piezasNoOk/periodo.totalPiezas) : 0;
      });

      return Object.values(dias).sort((a,b)=> new Date(a.fechaInicio) - new Date(b.fechaInicio));
    },
    
    agruparDatosPorSemanas(datos) {
      if (!datos || !datos.resumenDias || datos.resumenDias.length === 0) return [];

      const fechaInicio = moment(this.filtros.desde).startOf('isoWeek'); // lunes
      const fechaFin    = moment(this.filtros.hasta).endOf('isoWeek');   // domingo

      const semanas = {};
      let inicioSemana = fechaInicio.clone();

      while (inicioSemana.isSameOrBefore(fechaFin)) {
        const finSemana = inicioSemana.clone().endOf('isoWeek'); // domingo
        const isoYear = inicioSemana.isoWeekYear();
        const isoWeek = inicioSemana.isoWeek();
        const ww = String(isoWeek).padStart(2,'0');

        // etiqueta corta y id sortable por fecha
        const etiqueta = `Sem. ${ww} '${String(isoYear).slice(-2)}`;
        const id = Number(inicioSemana.format('YYYYMMDD'));

        semanas[etiqueta] = {
          id,
          etiqueta,
          fechaInicio: inicioSemana.format('YYYY-MM-DD'),
          fechaFin: finSemana.format('YYYY-MM-DD'),
          dias: [],
          disponibilidad: 0, rendimiento: 0, calidad: 0, oee: 0,
          totalPiezas: 0, piezasTeoricas: 0, piezasOk: 0, piezasNoOk: 0,
          tiempoActivo: 0, tiempoParos: 0, tiempoParoNoPlan: 0, tiempoBruto: 0, scrap: 0
        };

        inicioSemana.add(1, 'week');
      }

      // asigna días
      datos.resumenDias.forEach(dia => {
        const f = moment(dia.fecha);
        Object.values(semanas).forEach(sem => {
          if (f.isBetween(moment(sem.fechaInicio), moment(sem.fechaFin), null, '[]')) {
            sem.dias.push(dia);
          }
        });
      });

      // cálculos
      Object.values(semanas).forEach(sem => {
        if (!sem.dias.length) return;
        sem.totalPiezas     = sem.dias.reduce((s,d)=>s+d.totalPiezas,0);
        sem.piezasTeoricas  = sem.dias.reduce((s,d)=>s+d.piezasTeoricas,0);
        sem.piezasOk        = sem.dias.reduce((s,d)=>s+d.piezasOk,0);
        sem.piezasNoOk      = sem.dias.reduce((s,d)=>s+d.piezasNoOk,0);
        const tBruto        = sem.dias.reduce((s,d)=>s+(d.tiempoBruto*3600),0);
        const tNeto         = sem.dias.reduce((s,d)=>s+(d.tiempoNeto*3600),0);
        const tParos        = sem.dias.reduce((s,d)=>s+(d.tiempoParos*3600),0);
        const tNoPlan       = sem.dias.reduce((s,d)=>s+(d.tiempoParoNoPlan*3600),0);
        sem.tiempoBruto = tBruto; sem.tiempoActivo = tNeto; sem.tiempoParos = tParos; sem.tiempoParoNoPlan = tNoPlan;
        sem.disponibilidad = tBruto>0 ? ((tBruto - tNoPlan)/tBruto)*100 : 0;
        sem.rendimiento    = sem.piezasTeoricas>0 ? (sem.totalPiezas/sem.piezasTeoricas)*100 : 0;
        sem.calidad        = sem.totalPiezas>0 ? (sem.piezasOk/sem.totalPiezas)*100 : 0;
        sem.oee            = (sem.disponibilidad*sem.rendimiento*sem.calidad)/10000;
        sem.scrap          = sem.totalPiezas>0 ? (sem.piezasNoOk/sem.totalPiezas) : 0;
      });

      // lista ordenada por fecha real
      const lista = Object.values(semanas)
        .filter(s => s.dias.length > 0)
        .sort((a,b)=> new Date(a.fechaInicio) - new Date(b.fechaInicio));

      // si hay semanas seleccionadas, filtra
      if (this.filtros.semanasSeleccionadas?.length) {
        const sel = new Set(
          this.filtros.semanasSeleccionadas.map(s => `${s.year}-${String(s.week).padStart(2,'0')}`)
        );
        return lista.filter(s => {
          const y = moment(s.fechaInicio).isoWeekYear();
          const w = String(moment(s.fechaInicio).isoWeek()).padStart(2,'0');
          return sel.has(`${y}-${w}`);
        });
      }

      return lista;
    },
    
    agruparDatosPorMeses(datos) {
      if (!datos || !datos.resumenDias || datos.resumenDias.length === 0) {
        return [];
      }
      
      const meses = {};
      datos.resumenDias.forEach(dia => {
        const fechaDia = moment(dia.fecha);
        const mes = fechaDia.month() + 1;
        const año = fechaDia.year();
        
        if (!this.filtros.mesesSeleccionados.includes(mes) || año !== this.filtros.año) {
          return;
        }
        
        const nombreMes = this.mesesDisponibles.find(m => m.value === mes).text;
        const etiqueta = `${nombreMes} ${año}`;
        
        if (!meses[etiqueta]) {
          meses[etiqueta] = {
            id: mes,
            etiqueta: etiqueta,
            fechaInicio: moment(`${año}-${mes}-01`).format('YYYY-MM-DD'),
            fechaFin: moment(`${año}-${mes}-01`).endOf('month').format('YYYY-MM-DD'),
            dias: [],
            disponibilidad: 0,
            rendimiento: 0,
            calidad: 0,
            oee: 0,
            totalPiezas: 0,
            piezasTeoricas: 0,
            piezasOk: 0,
            piezasNoOk: 0,
            tiempoActivo: 0,
            tiempoParos: 0,
            tiempoParoNoPlan: 0,
            tiempoBruto: 0,
            scrap: 0
          };
        }
        
        meses[etiqueta].dias.push(dia);
      });
      
      // Cálculos para mes - caso NO-NYX (tiempos vienen en horas, convertir a segundos)
      Object.keys(meses).forEach(key => {
        const mes = meses[key];
        if (mes.dias.length > 0) {
          mes.totalPiezas = mes.dias.reduce((sum, dia) => sum + dia.totalPiezas, 0);
          mes.piezasTeoricas = mes.dias.reduce((sum, dia) => sum + dia.piezasTeoricas, 0);
          mes.piezasOk = mes.dias.reduce((sum, dia) => sum + dia.piezasOk, 0);
          mes.piezasNoOk = mes.dias.reduce((sum, dia) => sum + dia.piezasNoOk, 0);
          
          const tiempoBrutoTotal = mes.dias.reduce((sum, dia) => {
            return sum + (dia.tiempoBruto * 3600); // Convertir horas a segundos
          }, 0);
          const tiempoNetoTotal = mes.dias.reduce((sum, dia) => {
            return sum + (dia.tiempoNeto * 3600); // Convertir horas a segundos
          }, 0);
          const tiempoParosTotal = mes.dias.reduce((sum, dia) => {
            return sum + (dia.tiempoParos * 3600); // Convertir horas a segundos
          }, 0);
          const tiempoParoNoPlanTotal = mes.dias.reduce((sum, dia) => {
            return sum + (dia.tiempoParoNoPlan * 3600); // Convertir horas a segundos
          }, 0);
          
          mes.tiempoBruto = tiempoBrutoTotal;
          mes.tiempoActivo = tiempoNetoTotal;
          mes.tiempoParos = tiempoParosTotal;
          mes.tiempoParoNoPlan = tiempoParoNoPlanTotal;

          // Disponibilidad
          mes.disponibilidad = tiempoBrutoTotal > 0 ? 
            ((tiempoBrutoTotal - tiempoParoNoPlanTotal) / tiempoBrutoTotal) * 100 : 0;
          
          // Rendimiento
          mes.rendimiento = mes.piezasTeoricas > 0 ? 
            (mes.totalPiezas / mes.piezasTeoricas) * 100 : 0;
          
          // Calidad
          mes.calidad = mes.totalPiezas > 0 ? 
            (mes.piezasOk / mes.totalPiezas) * 100 : 0;
          
          // OEE
          mes.oee = (mes.disponibilidad * mes.rendimiento * mes.calidad) / 10000;
          
          // Scrap
          mes.scrap = mes.totalPiezas > 0 ? 
            (mes.piezasNoOk / mes.totalPiezas) : 0;
        }
      });
      
      return Object.values(meses).filter(mes => mes.dias.length > 0).sort((a, b) => a.id - b.id);
    },
    
    procesarDatosAgrupados(datos) {
      let periodos = this.esRangoDeUnDia()
        ? this.agruparDatosPorDias(datos)
        : this.agruparDatosPorSemanas(datos);

      if (periodos.length > 0) {
        const totalPiezasGlobal = periodos.reduce((sum, p) => sum + p.totalPiezas, 0);
        const piezasTeoricasGlobal = periodos.reduce((sum, p) => sum + p.piezasTeoricas, 0);
        const piezasOkGlobal = periodos.reduce((sum, p) => sum + p.piezasOk, 0);
        const piezasNoOkGlobal = periodos.reduce((sum, p) => sum + p.piezasNoOk, 0);
        const tiempoBrutoGlobal = periodos.reduce((sum, p) => sum + p.tiempoBruto, 0);
        const tiempoNetoGlobal = periodos.reduce((sum, p) => sum + p.tiempoActivo, 0);
        const tiempoParosGlobal = periodos.reduce((sum, p) => sum + p.tiempoParos, 0);
        const tiempoParoNoPlanGlobal = periodos.reduce((sum, p) => sum + p.tiempoParoNoPlan, 0);

        const disponibilidadGlobal = tiempoBrutoGlobal > 0 
          ? ((tiempoBrutoGlobal - tiempoParoNoPlanGlobal) / tiempoBrutoGlobal) * 100 
          : 0;

        const rendimientoGlobal = piezasTeoricasGlobal > 0 
          ? (totalPiezasGlobal / piezasTeoricasGlobal) * 100 
          : 0;

        const calidadGlobal = totalPiezasGlobal > 0 
          ? (piezasOkGlobal / totalPiezasGlobal) * 100 
          : 0;

        const oeeGlobal = (disponibilidadGlobal * rendimientoGlobal * calidadGlobal) / 10000;

        this.datosAgrupados = {
          disponibilidadPromedio: disponibilidadGlobal,
          rendimientoPromedio: rendimientoGlobal,
          calidadPromedio: calidadGlobal,
          oeePromedio: oeeGlobal,
          periodos: periodos
        };
      }

      this.generarSeriesAgrupadas();
    },
    
    generarSeriesAgrupadas() {
      const short = s => s.replace(/^Semana\s+(\d{1,2})\s+(\d{4})$/, (_, w, y) => `Sem. ${w} '${y.slice(-2)}`);

      this.chartOptions1 = [{
        name: 'Disponibilidad',
        data: this.datosAgrupados.periodos.map(p => ({
          x: p.etiqueta,
          y: Number(p.disponibilidad.toFixed(2)),
          fullLabel: `${p.fechaInicio} — ${p.fechaFin}` // si quieres tooltip más descriptivo
        }))
      }];
      this.chartOptions2 = [{
        name: 'Rendimiento',
        data: this.datosAgrupados.periodos.map(p => ({
          x: p.etiqueta,
          y: Number(p.rendimiento.toFixed(2)),
          fullLabel: `${p.fechaInicio} — ${p.fechaFin}` // si quieres tooltip más descriptivo
        }))
      }];
      this.chartOptions3 = [{
        name: 'Calidad',
        data: this.datosAgrupados.periodos.map(p => ({
          x: p.etiqueta,
          y: Number(p.calidad.toFixed(2)),
          fullLabel: `${p.fechaInicio} — ${p.fechaFin}` // si quieres tooltip más descriptivo
        }))
      }];
      this.chartOptions4 = [{
        name: 'OEE',
        data: this.datosAgrupados.periodos.map(p => ({
          x: p.etiqueta,
          y: Number(p.oee.toFixed(2)),
          fullLabel: `${p.fechaInicio} — ${p.fechaFin}` // si quieres tooltip más descriptivo
        }))
      }];
      this.configurarGraficas();
    },
    
    configurarGraficas() {
      const opcionesBase = (chartId) => ({
        chart: {
          id: chartId,          // ✅ CLAVE
          type: 'bar',
          toolbar: { show: true }, // recomendable para evitar defaults raros
          // NO pongas height aquí
        },

        plotOptions: { bar: { columnWidth: '45%', borderRadius: 4 } },

        xaxis: {
          type: 'category',
          labels: { rotate: -25, trim: true, hideOverlappingLabels: true },
          tickPlacement: 'top',
        },

        yaxis: {
          min: 0, max: 100, tickAmount: 5,
          labels: { formatter: val => `${val}%` }
        },

        dataLabels: {
          enabled: true,
          formatter: (val) => {
            const n = Number(val);
            return Number.isFinite(n) ? n.toFixed(2) + " %" : "—";
          },
          position: "top",
          style: {
            colors: ["#000"],
            fontSize: '23px',
            fontWeight: 900,
          },
        },

        tooltip: {
          x: {
            formatter: (val, opts) => {
              const p = opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex];
              return p?.fullLabel || val;
            }
          },
          y: { formatter: val => `${val}%` }
        }
      });

      this.serie1 = { ...opcionesBase('oee-disp'), colors: ['#118dff'] };
      this.serie2 = { ...opcionesBase('oee-rend'), colors: ['#ff8410'] };
      this.serie3 = { ...opcionesBase('oee-cal'),  colors: ['#10ff60'] };
      this.serie4 = { ...opcionesBase('oee-oee'),  colors: ['#ff372b'] };
    },
    
    obtenerDatos() {
      if (this.validate()) return;
      
      this.cargando = true;
      this.cargandoData = true;
      
      axios
        .get(this.url)
        .then((response) => {
          this.datos = response.data || {};
          this.procesarDatosAgrupados(this.datos);
          this.renderizar = true;
          this.cargando = false;
          this.cargandoData = false;
          this.forceChartsLayout();
          this.viewData = true;

          // Iniciar el carrusel sólo después de la primera carga completa
          if (this.carrusel?.enabled && !this.carrusel.timer) {
            this.startCarrusel();
          }
        })
        .catch((error) => {
          console.error(error);
          this.cargando = false;
          this.cargandoData = false;
          this.error = true;
          this.errores = ['Error al obtener los datos. Por favor, intente nuevamente.'];
          
          if (error.response && error.response.status === 404) {
            this.errores = ['No se encontraron datos para el periodo seleccionado.'];
          }
        });
    },
    
    validate() {
      this.errores = [];
      
      if (!this.filtros.desde || !this.filtros.hasta) {
        this.errores.push('Fechas no configuradas.');
      }
      
      this.error = this.errores.length > 0;
      return this.errores.length > 0;
    },
    
    descargarReporte(){
      var datetime = moment().format('YYYYMMDDHHmmss');
      this.$utils.axios.downloadFile(this.url2("/OEEV2/OEEReportTurnos"),'GET','reporte-oee-'+datetime+'.xlsx','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    },
    
    url2(path) {
      var url = `${path}?`;
      
      url += `Desde=${this.filtros.desde}&Hasta=${this.filtros.hasta}`;
      
      url += `&TipoAgrupacion=semana`;
      url += this.$utils.arrays.urlQuery(this.filtros.idsTurnos, "IdsTurnos", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsAreas, "IdsAreas", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsOTS, "IdsOTS", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsArticulos, "IdsArticulos", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsMaquinaInstancias, "IdsMaquinasInstancias", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsPersonas, "IdsPersonas", false);
      url += this.$utils.arrays.urlQuery(this.filtros.idsClientes, "IdsClientes", false);
      
      return url;
    },
    
    resetCampo(posicion) {
      switch (posicion) {
        case 1:
          this.filtros.idsTurnos = [];
          break;
        case 3:
          this.filtros.idsOTS = [];
          break;
        case 4:
          this.filtros.idsArticulos = [];
          break;
        case 5:
          this.filtros.idsMaquinaInstancias = [];
          break;
        case 6:
          this.filtros.idsPersonas = [];
          break;
        case 7:
          this.filtros.idsClientes = [];
          break;
      }
    },
    
    initialize() {
      this.getTurnos();
      this.getAreas();
      this.getOTS();
      this.getArticulos();
      this.getMaquinasIns();
      this.getOperadores();
      this.getClientes();
      
      const añoActual = new Date().getFullYear();
      for (let i = añoActual - 2; i <= añoActual; i++) {
        this.añosDisponibles.push(i);
      }
    },

    created() {
        this.extenderPantalla();
    },
    
    getTurnos() {
      axios.get("/Turnos")
        .then((response) => {
          this.turnos = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    
    getAreas() {
      axios.get("/Areas")
        .then((response) => {
          this.areas = response.data.filter(a => a.idArea > 1);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    
    getOTS() {
      axios.get(`/TrabajoOrdenes/TrabajoOrdenHeaders?soloEnProgreso=${false}`)
        .then((response) => {
          this.ots = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    
    getArticulos() {
      axios.get("/Articulos/OTS")
        .then((response) => {
          this.articulos = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    
    getMaquinasIns() {
      axios.get("/MaquinaInstancias")
        .then(response => {
          this.maquinasIns = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    
    getOperadores() {
      axios.get("/Personas/Operadores")
        .then((response) => {
          this.operadores = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    
    getClientes() {
      axios.get("/Clientes")
        .then(response => {
          response.data.unshift({
            idCliente: -1,
            nombre: this.nombreEmpresa,
          });
          this.clientes = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },

    async extenderPantalla() {
      const ref = this.$refs.fsRoot;
      const el = ref?.$el || ref;

      if (!el) return;

      const isFs = !!(document.fullscreenElement ||
                      document.webkitFullscreenElement ||
                      document.msFullscreenElement);

      try {
        if (!isFs) {
          await this._enterFullscreen(el);
        } else {
          await this._exitFullscreen();
        }
      } finally {
        this.isFullscreen = !!(document.fullscreenElement ||
                               document.webkitFullscreenElement ||
                               document.msFullscreenElement);
      }
    },

    async _enterFullscreen(el) {
      const anyEl = el;
      if (anyEl.requestFullscreen)              return anyEl.requestFullscreen();
      if (anyEl.webkitRequestFullscreen)        return anyEl.webkitRequestFullscreen();
      if (anyEl.msRequestFullscreen)            return anyEl.msRequestFullscreen();
      this.$toast && this.$toast.error?.('Pantalla completa no soportada en este navegador');
    },

    async _exitFullscreen() {
      const anyDoc = document;
      if (document.exitFullscreen)              return document.exitFullscreen();
      if (anyDoc.webkitExitFullscreen)          return anyDoc.webkitExitFullscreen();
      if (anyDoc.msExitFullscreen)              return anyDoc.msExitFullscreen();
    },
    
    recalcChartH() {
      //console.log("me llamaron");
      const root = this.$refs.fsRoot?.$el || this.$refs.fsRoot;
      const header = this.$refs.fsHeader?.$el || this.$refs.fsHeader;
      const metrics = this.$refs.metricsRow?.$el || this.$refs.metricsRow;
      if (!root) return;

      const rootH = root.clientHeight || 0;
      const headerH = header ? header.clientHeight : 0;
      const metricsH = metrics ? metrics.clientHeight : 0;

      const styles = window.getComputedStyle(root);
      const padTop = parseFloat(styles.paddingTop || "0") || 0;
      const padBot = parseFloat(styles.paddingBottom || "0") || 0;

      const gaps = 16;

      // aquí está el “90% / 80%”
      const factor = 0.90; // prueba 0.85 si aún recorta

      const chartsArea = Math.max(
        0,
        Math.floor((rootH - headerH - metricsH - padTop - padBot - gaps) * factor)
      );

      const perRow = Math.floor(chartsArea / 2);
      const cardChrome = 56;
      const h = perRow - cardChrome;

      this.chartH = Math.max(200, h);
    },

  _applyChartSize() {
    // si quieres conservar el nombre:
    this.recalcChartH();

    this.$nextTick(() => {
      // opcional: forzar resize de Apex si notas que se “corta”
      // ApexCharts.exec('ID_DEL_CHART', 'resize');
      // o si tienes ref: this.$refs.apex?.chart?.resize?.();
    });
  },
  forceChartsLayout() {
    this.$nextTick(() => {
      this.recalcChartH?.();

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          ['oee-disp','oee-rend','oee-cal','oee-oee'].forEach(id => {
            try { ApexCharts.exec(id, 'resize'); } catch(e) {}
          });
        });
      });
    });
  }
  },
  watch: {
    semanas: {
      deep: true,
      handler(v = []) {
        this.setRangeFromWeeks(v);
        this.filtros.semanasSeleccionadas = v.map(w => ({
          year: w.isoYear,
          week: w.isoWeek,
          desde: w.start,
          hasta: w.end,
          etiqueta: `Sem. ${String(w.isoWeek).padStart(2,'0')} '${String(w.isoYear).slice(-2)}`
        }));
      }
    }
  },
 mounted() {
  this.initialize?.();
  this.setRangoInicial?.();
  this.obtenerDatos?.();

  // 1) Recalcular por cambios reales de tamaño del contenedor (lo mejor)
  const root = this.$refs.fsRoot?.$el || this.$refs.fsRoot;
  if (root && window.ResizeObserver) {
    this._ro = new ResizeObserver(() => this._applyChartSize());
    this._ro.observe(root);

    const header = this.$refs.fsHeader?.$el || this.$refs.fsHeader;
    if (header) this._ro.observe(header);
  }

  // 2) Fallback por si no hay RO o por cambios externos
  this._onFsResize = () => this._applyChartSize();
  window.addEventListener('resize', this._onFsResize);

  // 3) Cuando el padre entra/sale fullscreen, cambia el layout → recalcula
  this._syncFs = () => this.$nextTick(() => this._applyChartSize());
  document.addEventListener('fullscreenchange', this._syncFs);
  document.addEventListener('webkitfullscreenchange', this._syncFs);
  document.addEventListener('MSFullscreenChange', this._syncFs);

  this.$nextTick(() => this._applyChartSize());
},

beforeDestroy() {
  this.stopCarrusel?.();

  if (this._ro) this._ro.disconnect();
  if (this._onFsResize) window.removeEventListener('resize', this._onFsResize);

  if (this._syncFs) {
    document.removeEventListener('fullscreenchange', this._syncFs);
    document.removeEventListener('webkitfullscreenchange', this._syncFs);
    document.removeEventListener('MSFullscreenChange', this._syncFs);
  }
}
};
</script>

<style scoped>
/* Root ocupa TODO el alto del tab/parent (no 100vh) */
.oee-surface{
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

/* Header fijo */
.oee-header{
  flex: 0 0 auto;
  padding: 4px 0;
}

/* Body flexible sin scroll */
.oee-body{
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* Fila de métricas */
.metrics-row {
  flex: 0 0 auto;
  min-height: 100px;
  max-height: 130px;
}

/* Fila de gráficos */
.charts-row {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

/* Metric cards centradas */
.metric-card {
  border-radius: 4px;
}

/* Charts: card en columna con body flexible */
.chart-card{
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  border-radius: 4px;
}

.chart-card /deep/ .v-card__title {
  padding: 4px 8px !important;
  line-height: 1.2;
}

.chart-body{
  flex: 1 1 auto;
  min-height: 0;
  padding: 4px !important;
}

/* Loading centrado */
.oee-loading{
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 0;
}
</style>

